import {Box, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import DataService from "../../../../../../Service";
import ChartLoader from "../ChartLoader";
import { makeStyles } from "@material-ui/core";
import { Bar } from "react-chartjs-2";
import NotFoundFallback from "./NotFoundFallBack";
import chartConstants from "../ChartConstants";
const useStyles = makeStyles((theme) => ({
  datePicker: {},
  datepickerPopover: {
    textAlign: "right",
    "& button": {
      backgroundColor: "#ffffff",
      border: "1px solid #d7dae2",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    },
  },

  selectClients: {
    "& .MuiSelect-select": {
      padding: "5px 8px !important",
    },
  },

  pieContainer: {
    width: "48.2%",
    transform: "translate(50%, 0)",
  },

  slaPieGraph: {
    width: "75%",
  },
  customTextField: {
    "& div": {
      padding: "0px !important",
      height: "47px",
    },
  },
}));

function EvaluationRatingsGraph(props) {
    const {plainView}=props;
    const {id:organisationId} = props.organisationId;
    const [chartLoader, setChartLoader] = useState(true);
    useEffect(() => {
        getEvaluationRating(organisationId,null);
        setChartLoader(true);
    }, [organisationId]);
    const [evaluationTableData, setEvaluationTableData] = useState(chartConstants.data);
  const [userData,setUserData] = useState({assignment:""})

  const onChangeItem = (selectedItemValue, inputId, routeFrom) => {
    console.log()
   
    setUserData(prev=>({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    }));
   
    if(selectedItemValue.id==="evaluation"){
      getEvaluationRating(null,
        selectedItemValue.value)
    }
  };
const options = {plugins:{legend:{align:"center"}},scales:{y:{ticks:{stepSize:1}}}}
  const getEvaluationRating = (organisationId,filter) => {
    var pdata =
      organisationId == null ? "" : "?organisation_id=" + organisationId;

    DataService.getDirectData(
      "dashboards/evaluation_dashboard" + pdata,
      {filter:filter?filter:undefined}
    ).then((res) => {
      const distinctCoach = {};
const response = res?.data?.filter(el=> (!(el.average ==="N/A" || el.coach_name=== null)));
response.forEach((el)=>{
        if(distinctCoach[el.coach_name]){
            distinctCoach[el.coach_name] = Math.round(((distinctCoach[el.coach_name]+el.average) / 2)*100)/100
        }else{
          distinctCoach[el.coach_name] = el.average
        }
});
console.log(distinctCoach,"distinct coach")
        setEvaluationTableData((prev)=>{          
            const updatedData = { ...prev };
            updatedData.datasets[0].label = "Average Rating";

            updatedData.datasets[0].data = Object.values(distinctCoach);
            updatedData.labels = Object.keys(distinctCoach);
            updatedData.datasets[0].backgroundColor=props.graphColor;
            return updatedData; 
          })
      setChartLoader(false);
    }).catch((err)=>console.error(err));
  };
  const MainStyle = {boxShadow:4,padding:1 }
  if(plainView){
    MainStyle.boxShadow = 0;
    MainStyle.padding = 0;
  }
  return (
    
     <Box width="100%">
          <Box {...MainStyle} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center" >
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                        paddingLeft:"15px",
                      }}
                        fontWeight="fontWeightBold"
                    >
                        Evaluation ratings
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={6}>
                    <CustomSelect
                      className={classes.selectClients}
                      id="evaluation"
                      labelText="Select assignments"
                      displayEmpty
                      variant="outlined"
                      itemArr={["Yes", "No"]}
                      parentcall={onChangeItem}
                      defaultValue={userData.evaluation}
                    />
                  </Grid> */}
                </Grid>
 
            {chartLoader ? (
              <ChartLoader />
            ) : (
              <EvaluationGraph evaluationTableData={evaluationTableData} options={{...chartConstants.options,...options}} />
            )}
          </Box>
          </Box>

  );
}

export default EvaluationRatingsGraph;

const EvaluationGraph = React.memo((props)=>{
    console.log(props,"evaluation data")
    const dataLength = props.evaluationTableData.datasets[0].data.length;
    const labelLength = props.evaluationTableData.labels.length;
return (
    <>
      {(dataLength > 0 && labelLength > 0) ? (
        <Bar
          key={(Math.random()*1232151) +1}
          id={props?.organisation}
          data={props?.evaluationTableData}
          options={props?.options}
        />
      ) : (
        <NotFoundFallback />
      )}
    </>
  );
},(preProps, nextProps) => {
    return (
      JSON.stringify(preProps.evaluationTableData) ===
      JSON.stringify(nextProps.evaluationTableData)
    );
  });

const EvaluationTable = React.memo(
  (props) => (
    <>
      <br />
      <Grid item xs={12} style={{paddingLeft:"1rem",paddingRight:"1rem"}}>
        <Grid
          container
          direction="row"
          spacing={2}
          style={{ backgroundColor: "#F5F6FA", height: 45, paddingTop: 10,paddingLeft:"1rem",paddingRight:"1rem"}}
        >
          <Grid item xs={5}>
            <Typography variant="h2">
              <Box fontWeight="fontWeightBold">Coach name</Box>
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <Typography variant="h2">
              <Box fontWeight="fontWeightBold">
                Average rating across assignments
              </Box>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {props.evaluationTableData.length > 0 ? (
        props.evaluationTableData.map((option) => {
          return (
            <Grid item xs={12}  style={{paddingLeft:"1rem",paddingRight:"1rem"}}>
              <Grid container direction="row" style={{paddingLeft:"1rem",paddingRight:"1rem"}} spacing={2} gap={1} >
                <Grid item xs={6} style={{ paddingTop: "10px" }}>
                  <Typography variant="h2">
                    {option.coach_name ? (
                      <Box>{option.coach_name}</Box>
                    ) : (
                      <Box alignItems="center" paddingLeft={"2px"}>
                        -
                      </Box>
                    )}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ paddingTop: "10px", marginLeft: "-43px" }}
                >
                  <Typography variant="h2">
                    <Box>{option.average}</Box>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        })
      ) : (
        <Grid item xs={12} style={{ height: "25.3vh" }}>
          <Typography
            variant="subtitle1"
            style={{ paddingTop: 68, textAlign: "center" }}
          >
            No data available
          </Typography>
        </Grid>
      )}
    </>
  ),
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.evaluationTableData) ===
      JSON.stringify(nextProps.evaluationTableData)
    );
  }
);
